const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['check-performance-route'] = require('../middleware/check-performance-route.js')
middleware['check-performance-route'] = middleware['check-performance-route'].default || middleware['check-performance-route']

middleware['check-user-permissions'] = require('../middleware/check-user-permissions.js')
middleware['check-user-permissions'] = middleware['check-user-permissions'].default || middleware['check-user-permissions']

export default middleware
